import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthCardLayout from "layouts/AuthCardLayout";
import RegistrationForm from "components/authentication/RegistrationForm";
import { Button, Row, Col } from "react-bootstrap";
import ContentSuccess from "../ContentSuccess";
import logo from 'assets/img/favicons/android-chrome-512x512.png';

const Registration = () => {
  const [showSucessMessage, setShowSucessMessage] = useState(false);
  const [email, setEmail] = useState("");

  const sucessMessageHandle = (status, email) => {
    setShowSucessMessage(status);
    setEmail(email);
  };
  return (
    <AuthCardLayout
      leftSideContent={
        <p className="pt-3 text-white">
          Have an account?
          <br />
          <Button
            as={Link}
            variant="outline-light"
            className="mt-2 px-4"
            to="/authentication/login"
          >
            Log In
          </Button>
        </p>
      }
      footer={false}
    >
      {showSucessMessage ? (
        <>
          <ContentSuccess
            layout="card"
            titleTag="h3"
            title="Verify your email"
            sub="Please check your email!"
            content={`An email has been sent to ${email} for the confirmation`}
          />
        </>
      ) : (
        <>
        <div>
          <Link
            className="text-white text-decoration-underline"
            to="/landing"
          >
            <div style={{marginBottom: "20px"}} className="d-flex justify-content-center align-items-center d-block d-sm-none">

            <img
              className="text-center"
              src={logo}
              alt=""
              width={40}
              style={{marginRight:"5px"}}
          />
            <h5 className="text-center " style={{color:"#2c87f2", fontWeight: "800", fontSize: "26px"}}>FNOTrader</h5>
           </div>
           </Link>
        </div>
          <h3 className="text-center">Register</h3>
          <RegistrationForm
            layout="card"
            hasLabel
            sucessMessageHandle={sucessMessageHandle}
          />
           <Row className="h-100 g-0">
            <Col md={12} xs={12} sm={12}  className="d-block d-sm-none">
              <p   className="fs--1 text-600  text-center">
                Already Registered? <Link to="/authentication/login">Click here to login</Link>
              </p>
            </Col>  
          </Row>
        </>
      )}
    </AuthCardLayout>
  );
};

export default Registration;
